import { render } from "./InstagramRedirectView.vue?vue&type=template&id=6961f894"
import script from "./InstagramRedirectView.vue?vue&type=script&lang=js"
export * from "./InstagramRedirectView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__